/**
 * Consent-aware analytics integration.
 *
 * Google Store Rating is owned by the original Google & YouTube app embed.
 * Keeping it there preserves the embed's configured desktop and mobile layout.
 */
(function () {
  'use strict';

  var config = document.getElementById('ff-consent-integrations');
  if (!config) return;

  var ahrefsKey = config.dataset.ahrefsKey || '';
  var ahrefsScriptId = 'ff-ahrefs-analytics';

  function analyticsAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    return Boolean(
      privacy &&
        privacy.analyticsProcessingAllowed &&
        privacy.analyticsProcessingAllowed()
    );
  }

  function loadAhrefs() {
    if (
      !analyticsAllowed() ||
      !ahrefsKey ||
      document.getElementById(ahrefsScriptId)
    ) {
      return;
    }

    var script = document.createElement('script');
    script.id = ahrefsScriptId;
    script.async = true;
    script.src = 'https://analytics.ahrefs.com/analytics.js';
    script.dataset.key = ahrefsKey;
    document.body.appendChild(script);
  }

  function removeAhrefs() {
    var script = document.getElementById(ahrefsScriptId);
    if (script) script.remove();
  }

  function syncAnalytics() {
    if (analyticsAllowed()) {
      loadAhrefs();
    } else {
      removeAhrefs();
    }
  }

  function loadPrivacyApi() {
    window.Shopify = window.Shopify || {};

    if (window.Shopify.customerPrivacy) {
      syncAnalytics();
      return;
    }

    if (typeof window.Shopify.loadFeatures !== 'function') return;

    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (!error) syncAnalytics();
      }
    );
  }

  document.addEventListener('visitorConsentCollected', syncAnalytics);
  document.addEventListener('shopifyCustomerPrivacyApiLoaded', syncAnalytics);
  window.addEventListener('pageshow', loadPrivacyApi);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadPrivacyApi, { once: true });
  } else {
    loadPrivacyApi();
  }
})();
